import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Textfield from "../../shared/textfield";
// import AccessLocalStorage from "../../../services/localStorage";

// import { getApiUrl } from "../../../services/api_service";
import dayjs from "dayjs";
import { buttonRed, pcolor, textFieldOptional, textFieldOutlineDisabled, textFieldTitle, title } from "../../../style2";

export default function ChildYoungPersonDetails(props) {
    const [disabledField, setDisabledField] = useState(true);
  const [gender, setGender] = useState(0);
  const [isThereAnotherHome, setIsThereAnotherHome] = useState("no");
  //const ls = new AccessLocalStorage();
  // const handleEdit = () => {
  //   setDisabledField(!disabledField);
  //   if (!disabledField) {
  //     // To save changes here
  //   }
  // };

  const handleCancelEdit = () => {
    setDisabledField(true);
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleIsThereAnotherHome = (event) => {
    setIsThereAnotherHome(event.target.value);
  };

  const handleFindAddress = () => { };

  const [profile, setProfile] = useState(props.profile);
  //const [loading, setLoading] = useState(true);
  //const [error, setError] = useState(null);

  // useEffect(() => {
  //   const authTokens = localStorage.getItem("authTokens");
  //   let token;

  //   if (authTokens) {
  //     const parsedAuthTokens = JSON.parse(authTokens);
  //     token = parsedAuthTokens?.accessToken;
  //   }
  //   if (!token) {
  //     setError("Unauthorized. No token available.");
  //     setLoading(false);
  //     return;
  //   }

  //   fetch(
  //     `${getApiUrl()}${process.env.REACT_APP_GET_PROFILE}/${ls.getCurrentPatientId()}`,
  //     {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //       setProfile(data);
  //     })
  //     .catch((err) => {
  //       setError(err.message || "An error occurred.");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, []);

  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>
            Child/Young Person Details
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title={"First Name"} value={profile.user?.firstName} disabled={disabledField} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='Surname' value={profile.user?.surname} disabled={disabledField} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='Date of Birth' value={dayjs(profile.user?.dob).format("DD/MM/YYYY")} disabled={disabledField} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='Gender' value={String(profile.user?.gender) === "1" ? "Male" : String(profile.user?.gender) === "2" ? "Female" : String(profile.user?.gender) === "3" ? "Neutral" : ""} disabled={disabledField} />
          {/* <Select value={String(profile.user?.gender)} onChange={handleGenderChange} disableUnderline
            sx={{...(disabledField
                ? textFieldOutlineDisabled
                : textFieldOptional), width: "100%" }} disabled={disabledField}>
            <MenuItem value={1}>Male</MenuItem>
            <MenuItem value={2}>Female</MenuItem>
            <MenuItem value={3}>Neutral</MenuItem>
          </Select> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='NHS Number' value={profile.user?.nhsNumber} disabled={disabledField} />
        </Grid>
        {profile.personalInformation?.gpPractice?.name && profile.personalInformation?.gpPractice?.name !== "" ? <Grid item xs={12} sm={6}>
          <Textfield title='GP Practice' value={profile.personalInformation?.gpPractice?.name} disabled={disabledField} />
        </Grid> : null}
        {profile.personalInformation?.gpName && profile.personalInformation?.gpName !== "" ? <Grid item xs={12} sm={6}>
          <Textfield title='Your GP' value={profile.personalInformation?.gpName} disabled={disabledField} />
        </Grid> : null}
        {profile.personalInformation?.hospital?.name && profile.personalInformation?.hospital?.name !== "" ? <Grid item xs={12} sm={6}>
          <Textfield title='Hospital' disabled={disabledField} value={profile.personalInformation?.hospital?.name} />
        </Grid> : null}
      </Grid>
      <Box m={2} />
      <Divider />
      <Box m={2} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>Address Details</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='Post Code' value={profile.user?.postCode} disabled={disabledField} />
        </Grid>
        {!disabledField && (
          <Grid item xs={12} sm={6}>
            <Box m={3} />
            <Button sx={buttonRed} onClick={handleFindAddress}>
              Find Address
            </Button>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <Textfield title='House Name/Number' value={profile.user?.doorNumber} disabled={disabledField} />
        </Grid>
        <Grid item xs={12}>
          <Textfield title='Address' value={profile.user?.address} disabled={disabledField} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='Town/City' value={profile.user?.city} disabled={disabledField} />
        </Grid>
      </Grid>
      <Box m={2} />
      <Divider />
      <Box m={2} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>
            Parent/Carer Details
          </Typography>
        </Grid>
        {profile.user?.parentName && profile.user?.parentName !== "" ? <Grid item xs={12} sm={6}>
          <Textfield title='Name(s) of Guardian/Carer' value={profile.user?.parentName} disabled={disabledField} />
        </Grid> : null}
        {profile.user?.relationship && profile.user?.relationship !== "" ? <Grid item xs={12} sm={6}>
          <Textfield title='Relationship' value={profile.user?.relationship} disabled={disabledField} />
        </Grid> : null}
      </Grid>
      <Box m={2} />
      <Divider />
      <Box m={2} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>
            Child’s contacts and Household
          </Typography>
        </Grid>
        {profile.familyInformation?.whoLivesInChildPrimaryHome && profile.familyInformation?.whoLivesInChildPrimaryHome !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Who lives with or is often in your child’s primary home?'
              value={profile.familyInformation?.whoLivesInChildPrimaryHome}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.familyInformation?.isAnotherChildHome ?
          <Grid item xs={12} sm={4}>
            
            <FormControl>
                <FormLabel sx={{color: pcolor}}>Is there another home that your child lives in?</FormLabel>
            <RadioGroup row value={String(profile.familyInformation?.isAnotherChildHome)} onChange={handleIsThereAnotherHome}>
              <FormControlLabel value='true' control={<Radio />} label='Yes' disabled={disabledField} />
              <FormControlLabel value='false' control={<Radio />} label='No' disabled={disabledField} />
            </RadioGroup></FormControl>
            
          </Grid> : null}
        {profile.familyInformation?.isAnotherChildHome && profile.familyInformation?.whoLivesInChildSecondaryHome && profile.familyInformation?.whoLivesInChildSecondaryHome !== "" ? 
          <Grid item xs={12} sm={8}>
          <Textfield title='Who lives with or is often in the child’s secondary home?' 
          disabled={disabledField} value={profile.familyInformation?.whoLivesInChildSecondaryHome} />
        </Grid> : null
        }
      </Grid>
      {/* <Box m={2} />
      <Grid container alignItems='center' justifyContent='flex-end'>
        {!disabledField && (
          <>
            <Button type='submit' className={classes.buttonRed} onClick={handleCancelEdit}>
              Cancel
            </Button>
            <Box m={2} />
          </>
        )}
        <Button type='submit' className={classes.buttonRed} onClick={handleEdit}>
          {disabledField ? "Edit Profile" : "Save Changes"}
        </Button>
      </Grid> */}
    </Box>
  );
}
